/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { gatewaySessionsList } from "../funcs/gatewaySessionsList.js";
import { gatewaySessionsListFacets } from "../funcs/gatewaySessionsListFacets.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { GatewaySessionFacets } from "../models/components/gatewaysessionfacets.js";
import {
  ListGatewaySessionFacetsRequest,
  ListGatewaySessionFacetsSecurity,
} from "../models/operations/listgatewaysessionfacets.js";
import {
  ListGatewaySessionsRequest,
  ListGatewaySessionsResponse,
  ListGatewaySessionsSecurity,
} from "../models/operations/listgatewaysessions.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class GatewaySessions extends ClientSDK {
  /**
   * listGatewaySessions gatewaySessions
   */
  async list(
    request?: ListGatewaySessionsRequest | undefined,
    security?: ListGatewaySessionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListGatewaySessionsResponse, { cursor: string }>> {
    return unwrapResultIterator(gatewaySessionsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listGatewaySessionFacets gatewaySessions
   *
   * @remarks
   * Complete configured member server and provider choices, independent of pagination and active filters.
   */
  async listFacets(
    request?: ListGatewaySessionFacetsRequest | undefined,
    security?: ListGatewaySessionFacetsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GatewaySessionFacets> {
    return unwrapAsync(gatewaySessionsListFacets(
      this,
      request,
      security,
      options,
    ));
  }
}
